var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.127312 5.79175C0.338202 6.07298 0.737114 6.12996 1.01822 5.91904L6.99987 1.432L12.9818 5.91904C13.263 6.12996 13.6618 6.0729 13.8727 5.79175C14.0836 5.51056 14.0266 5.11159 13.7454 4.90071L7.38165 0.127263C7.2685 0.0424017 7.13419 -2.87336e-05 6.99983 -2.87454e-05C6.86552 -2.87571e-05 6.73116 0.0424016 6.61801 0.127263L0.254583 4.90071C-0.0265597 5.11159 -0.0835781 5.51052 0.127312 5.79175Z",
    fill: "#29185E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.127312 8.74536C0.338202 9.02659 0.737114 9.08358 1.01822 8.87265L6.99987 4.38562L12.9818 8.87266C13.263 9.08358 13.6618 9.02651 13.8727 8.74536C14.0836 8.46418 14.0266 8.0652 13.7454 7.85432L7.38165 3.08088C7.2685 2.99601 7.13419 2.95358 6.99983 2.95358C6.86552 2.95358 6.73116 2.99601 6.61801 3.08088L0.254583 7.85432C-0.0265597 8.0652 -0.0835781 8.46413 0.127312 8.74536Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.ef2a57c5fcddeec9cb3e36696d86ad12.svg";
export { ForwardRef as ReactComponent };